import Component from '../../../components/Component';

import keys from './keys';
import query from './query';
import ListData from '../../../components/ListData';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }
    render() {
        return (
            <ListData
                loading={this.state.loading}
                header={this.props.header ?? 'Top Pages'}
                subheader={this.props.subheader ?? '(by clicks)'}
                forceRun={this.forceRun}
                link={`/domain/${this.props.domain_id}/gsc-reports/urls`}
                keys={keys}
                uniqKey="level"
                data={this.state.data}
                cardClassName={'list-data-full'}
            />
        );
    }
}

export default Summary;
